import type { EventDto } from '../../events/response/event.dto';
import type { Address } from '@/types/dtos/organizations/address.dto.ts';
import type { UserDto } from '@/types/dtos/user/response/user.dto.ts';
import type { OrderLineItemDto } from '@/types/dtos/orders/response/order-line-item.dto.ts';

export const ORDER_ENTITY = {
  EVENT: 'Event',
} as const;

export type OrderEntity = (typeof ORDER_ENTITY)[keyof typeof ORDER_ENTITY];

export const ORDER_STATUS = {
  DRAFT: 'DRAFT',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAID: 'PAID',
} as const;

export type OrderStatus = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS];

export type OrderDto = {
  id: string;
  entityType: OrderEntity;
  entity: EventDto;
  status: OrderStatus;
  lineItems: OrderLineItemDto[];
  totalPrice: number;
  vat: number;
  totalPriceWithVat: number;
  billingAddress?: Address;
  createdBy: UserDto;
  invoiceId?: string;
  createdAt: string;
};
